import React from "react";
import { ICooperativeDetails } from "../../exports/interfaces";
import { Info } from "./CooperativeDetails";
import useMobile from "../../hooks/useMobile";
import { Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { usePermission } from "../../hooks/usePermission";

const AddressInfo = ({
  cooperative,
}: {
  cooperative: ICooperativeDetails | null;
}) => {
  const isMobile = useMobile();
  const { canEdit } = usePermission();
  const navigate = useNavigate();
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h6 className="primary-color">Cooperatives Address Info</h6>
        {canEdit("cooperatives") && (
          <button
            className="btn px-3 btn-badge fs-small"
            onClick={() =>
              navigate(`/register/edit/${cooperative?.id}`, {
                state: {
                  step: 1,
                },
              })
            }
          >
            <i className={`${!isMobile ? "me-2" : ""}`}>
              <Pencil size={15} />
            </i>
            {!isMobile && "Edit"}
          </button>
        )}
      </div>
      <div className="row g-3">
        <Info label="Province" value={cooperative?.address?.province || "-"} />

        <Info label="District" value={cooperative?.address?.district || "-"} />

        <Info
          label="Municipality (Local Level)"
          value={cooperative?.address?.municipality || "-"}
        />

        <Info
          label="Street / Tole"
          value={cooperative?.address?.streetTole || "-"}
        />

        <Info label="Ward" value={cooperative?.address?.ward ?? "-"} />
      </div>

      <hr />
    </>
  );
};

export default AddressInfo;
